import { Component, inject } from '@angular/core';
import { FormControl, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { IDialogOptions, PromptDialogService } from '@lc/core';
import { MatIcon } from '@angular/material/icon';
import { MatButton } from '@angular/material/button';
import { E2eIdDirective } from '@lc/ui/lib/core';
import { ICardOption } from '../../inputs';
import { BaseDialog } from '../base/base.dialog';
import { CardSelectComponent } from '../../inputs/card-select/card-select.component';

export type UserSelection = 'current-user' | 'obo-user';
export interface IUserSelectDialogData {
  header?: string;
  subheader?: string;
}

@Component({
  selector: 'lc-user-select',
  templateUrl: './user-select.dialog.html',
  styleUrls: ['./user-select.dialog.scss'],
  imports: [
    BaseDialog,
    CardSelectComponent,
    FormsModule,
    ReactiveFormsModule,
    MatIcon,
    MatButton,
    E2eIdDirective,
  ],
})
export class UserSelectDialog {
  readonly data? = inject<IUserSelectDialogData>(MAT_DIALOG_DATA, { optional: true });
  private readonly dialogRef = inject<MatDialogRef<UserSelectDialog, any>>(MatDialogRef, { optional: true });

  /**
   * Opens the form as a dialog
   */
  static async open(service: PromptDialogService, data?: IUserSelectDialogData, options?: IDialogOptions): Promise<UserSelection> {
    return await service.openComponent(UserSelectDialog, data, options);
  }

  readonly value = new FormControl(null, [Validators.required]);
  public readonly options: ICardOption<string>[] = [
    { label: 'Yourself', value: 'current-user' },
    { label: 'Someone Else', value: 'obo-user' },
  ];

  onContinue() {
    if (this.value.invalid) {
      this.value.markAsDirty();
      this.value.markAsTouched();
      return this.value.updateValueAndValidity();
    }
    this.dialogRef?.close(this.value.value);
  }

  onActionClicked(_event) {
    this.dialogRef?.close();
  }
}
